import dayjs from 'dayjs'

export const MEMBER_BIRTHDAY_AGE_MIN = 18
export const MEMBER_BIRTHDAY_AGE_MAX = 100
export const MEMBER_BIRTHDAY_AGE_DEFAULT = 30

export type MemberBirthdayInput = string | null | undefined

const MEMBER_BIRTHDAY_INPUT_REGEX = /^\d{8}$/

function parseSanitizedMemberBirthdayInput(sanitizedBirthday: string) {
  if (!MEMBER_BIRTHDAY_INPUT_REGEX.test(sanitizedBirthday)) return null

  const year = Number(sanitizedBirthday.slice(0, 4))
  const month = Number(sanitizedBirthday.slice(4, 6))
  const day = Number(sanitizedBirthday.slice(6, 8))
  const parsedDate = dayjs(new Date(year, month - 1, day))

  if (!parsedDate.isValid() || parsedDate.format('YYYYMMDD') !== sanitizedBirthday) return null

  return {
    date: parsedDate.toDate(),
    value: parsedDate.format('YYYY-MM-DD'),
  }
}

export function sanitizeMemberBirthdayInput(value: MemberBirthdayInput) {
  return String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, 8)
}

export function normalizeMemberBirthdayInput(value: MemberBirthdayInput) {
  return parseSanitizedMemberBirthdayInput(sanitizeMemberBirthdayInput(value))?.value ?? ''
}

export function getMemberBirthdayRange(today = new Date()) {
  return {
    min: dayjs(today).subtract(MEMBER_BIRTHDAY_AGE_MAX, 'year').startOf('day').toDate(),
    max: dayjs(today).subtract(MEMBER_BIRTHDAY_AGE_MIN, 'year').startOf('day').toDate(),
  }
}

export function isValidMemberBirthdayInput(value: MemberBirthdayInput) {
  const birthday = parseSanitizedMemberBirthdayInput(sanitizeMemberBirthdayInput(value))
  if (!birthday) return false

  const { min, max } = getMemberBirthdayRange()

  return birthday.date >= min && birthday.date <= max
}
